// @flow
import React from "react"
import Button from "components/Button"
import { compose, withHandlers, type HOC } from "recompose"
import { NextWrapper } from "./styled"

const Next = ({ handleClick, disabled, loading }) => (
  <React.Fragment>
    <NextWrapper>
      <Button loading={loading} disabled={disabled} fullwidth onClick={handleClick}>
        Next
      </Button>
    </NextWrapper>
  </React.Fragment>
)

type Outter = {
  incrementStep: Function,
  disabled: boolean,
  loading: boolean,
}

const enhancer: HOC<*, Outter> = compose(
  withHandlers({
    handleClick: props => () => {
      props.incrementStep()
    },
  }),
)
export default enhancer(Next)



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/Next/index.js